import AddButton from "components/AddButton";
import CardReaderCard from "components/CardReaderCard";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  addCardReaderForm,
  addedCardReader,
  cardReaderDatas,
  cardReaderEditIndexState,
  CardReaderForEdit,
  cardReaderFormState,
  recordNumberForEdit,
  updatedCardReader,
} from "../atoms/atoms";
import { toast } from "components/toastNotification";
import ConfirmBoxDelete from "components/ConfirmBoxDelete";
import useDeleteCardReader from "../hooks/useDeleteCardReader";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";

enum ActionType {
  ADD = "Add Card Reader",
  EDIT = "Edit Card Reader ",
  DELETE = "DELETE",
  NONE = "NONE",
  UPDATE = "Update Initial Add CardReader",
}
const CardReaderSection = ({ recNumber, data, securityFormAction }) => {
  const [, setDataCardReader] = useRecoilState(cardReaderDatas);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [indexToRemove, setIndexToRemove] = useState<number | null>(null);
  const [cardReaderData, setCardReaderData] = useState(data);
  const [selectedCardReader, setSelectedCardReader] = useState<any>();
  const [, setIsOpenCardReaderModal] = useState(false);
  const [, setAction] = useState<ActionType>(ActionType.NONE);

  //delete
  const { mutate: deleteCardReader } = useDeleteCardReader();
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [, setCardReaderActionState] = useRecoilState(cardReaderFormState);

  //permissions
  const [hasDeletePermission, setHasDeletePermission] = useState(false);
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_security_add;
  const deletePermission = PERMISSIONS.permission_security_delete;

  useEffect(() => {
    if (userPermissions.includes(deletePermission)) {
      setHasDeletePermission(true);
    }
  }, []);

  const handleOpenCardModal = (action: ActionType, cardReader) => {
    setSelectedCardReader(cardReader);
    setDataCardReader(cardReader);
    setIsOpenCardReaderModal(true);
    setAction(action);
    setCardReaderActionState(action);
  };

  const handleDeactivate = () => {
    if (!selectedCardReader) return;

    const payload = {
      id: selectedCardReader.id,
      recordNumber: selectedRecordNumber,
    };

    deleteCardReader(payload, {
      onSuccess: () => {
        toast.fire(
          "Success",
          "Card reader deactivated successfully!",
          "success"
        );
        setCardReaderData((prev) =>
          prev.map((item) =>
            item.id === payload.id ? { ...item, isActive: false } : item
          )
        );
        setShowDeactivateModal(false);
      },
      onError: () => {
        toast.fire("Failed", "Card reader deactivation failed!", "error");
      },
    });
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">
      {"Are you sure you want to deactivate this Card Reader?"}
    </div>
  );
  const [selectedRecordNumber] = useRecoilState(recordNumberForEdit);
  const handleOpenCardModalDelete = (action: ActionType, cardReader) => {
    setSelectedCardReader(cardReader);
    setShowDeactivateModal(true);
    setAction(action);
  };

  const [newlyUpdatedCardReader] = useRecoilState(updatedCardReader);
  useEffect(() => {}, [newlyUpdatedCardReader]);
  const [secCardReader, setSecCardReader] =
    useRecoilState<any>(addCardReaderForm);
  const [newlyAddedCardReader] = useRecoilState(addedCardReader);
  const [, setEditIndex] = useRecoilState(cardReaderEditIndexState);
  const [cardReaderForEdit] = useRecoilState(CardReaderForEdit);

  // useEffect for updating the data in the cardradercard

  //useeffect to load data from office/edit
  useEffect(() => {
    if (Array.isArray(cardReaderForEdit) && cardReaderForEdit.length > 0) {
      setCardReaderData(cardReaderForEdit);
    } else {
      setCardReaderData(data);
    }
  }, [cardReaderForEdit, data]);

  useEffect(() => {
    if (newlyAddedCardReader.length > 0) {
      setCardReaderData((prev) => {
        const existingIds = new Set(prev.map((item) => item.id));

        const filteredNew = newlyAddedCardReader
          .filter((item) => !existingIds.has(item.id))
          .map((item) => ({
            ...item,
            isActive: true, //always true when add
          }));

        return [...prev, ...filteredNew];
      });
    }
  }, [newlyAddedCardReader]);

  useEffect(() => {
    if (
      Array.isArray(newlyUpdatedCardReader) &&
      newlyUpdatedCardReader.length > 0
    ) {
      setCardReaderData((prev) => {
        const updatesMap = new Map(
          newlyUpdatedCardReader.map((item) => [item.id, item])
        );

        return prev.map((item) =>
          updatesMap.has(item.id) ? updatesMap.get(item.id)! : item
        );
      });
    }
  }, [newlyUpdatedCardReader]);

  const handleRemove = () => {
    if (indexToRemove !== null) {
      setSecCardReader((prevData) =>
        prevData.filter((_, i) => i !== indexToRemove)
      );
      setIndexToRemove(null);
    }
    setShowRemoveModal(false);
  };
  const handleOpenCardModalRemove = (index) => {
    setIndexToRemove(index);
    setShowRemoveModal(true);
  };

  const removeMessage = (
    <div className="text-gray-500 font-normal">
      {"Are you sure you want to remove this Card Reader?"}
    </div>
  );
  return (
    <div className=" mx-2 mt-2 bg-white box-shadow rounded-lg h-full">
      <div className="flex flex-row justify-between py-2">
        <div className="text-quinary font-bold font-sans px-4">
          Card Reader Section
        </div>
        <div className="py-2 px-4">
          {userPermissions.includes(addPermission) ? (
            (secCardReader?.length ?? 0) >= 5 ||
            (cardReaderData?.length ?? 0) >= 5 ? (
              <div className="h-6"></div>
            ) : (
              <AddButton
                className="opacity-100"
                buttonText="Add Card Reader"
                onClick={() => {
                  let defaultData = { recordNumber: undefined };
                  if (
                    securityFormAction === "ADD" &&
                    cardReaderData !== undefined
                  ) {
                    defaultData = cardReaderData[0];
                  }
                  handleOpenCardModal(ActionType.ADD, defaultData);
                }}
              />
            )
          ) : (
            <div className="h-6"></div>
          )}
        </div>
      </div>

      <div className="w-full borderContainer -mt-4 pb-4 bg-white px-4">
        {securityFormAction === "EDIT" ? (
          <div className="grid gap-2 grid-cols-5">
            {cardReaderData &&
              cardReaderData.map((cardreader) => (
                <div key={cardreader.id}>
                  <CardReaderCard
                    cardReader={cardreader}
                    onClickEdit={() => {
                      handleOpenCardModal(ActionType.EDIT, cardreader);
                    }}
                    onClickDelete={() => {
                      handleOpenCardModalDelete(ActionType.DELETE, cardreader);
                    }}
                    onClickView={() => {}}
                    isEditState
                    hideRemove
                    hasDeletePermission={hasDeletePermission}
                  />
                </div>
              ))}
          </div>
        ) : securityFormAction === "ADD" ? (
          <div className="text-quinary font-bold font-sans grid gap-2 grid-cols-5 ">
            {secCardReader &&
              secCardReader.map((cardreader, index) => {
                return (
                  <div key={cardreader.id}>
                    {
                      <CardReaderCard
                        cardReader={cardreader}
                        onClickEdit={() => {
                          handleOpenCardModal(ActionType.EDIT, cardreader);
                          setEditIndex(index);
                        }}
                        onClickDelete={() => {
                          setSecCardReader((prevData) =>
                            prevData.filter((_, i) => i !== index)
                          );
                        }}
                        onClickRemove={() => {
                          handleOpenCardModalRemove(index);
                        }}
                        hideDelete
                        hideRemove={
                          indexToRemove !== null && index === indexToRemove
                        }
                        editHidden={
                          indexToRemove !== null && index === indexToRemove
                        }
                        onClickView={() => {}}
                        isEditState
                        hasDeletePermission={false}
                      />
                    }
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="text-quinary font-bold font-sans py-2 px-4">
            <h1
              className="mr-auto truncate w-full cursor-pointer text-ellipsis font-bold text-primary underline text-lg uppercase"
              onClick={() => {
                handleOpenCardModal(ActionType.ADD, cardReaderData[0]);
              }}
            >
              {cardReaderData &&
                cardReaderData[0]?.vendorId &&
                "View Card Reader/s"}
            </h1>
          </div>
        )}
      </div>

      {showDeactivateModal && (
        <ConfirmBoxDelete
          ModalTitle="Card Reader"
          qConfirmation={deleteMessage}
          isOpen={showDeactivateModal}
          onClose={() => setShowDeactivateModal(false)}
          onClickFunction={handleDeactivate}
          cancelButtonRef={undefined}
        />
      )}
      {showRemoveModal && (
        <ConfirmBoxDelete
          ModalTitle="Card Reader"
          qConfirmation={removeMessage}
          isOpen={showRemoveModal}
          onClose={() => {
            setShowRemoveModal(false);
            setIndexToRemove(null);
          }}
          onClickFunction={handleRemove}
          cancelButtonRef={undefined}
        />
      )}
    </div>
  );
};

export default CardReaderSection;
